import PropTypes from 'prop-types';

import { PROJECT_REFERRAL_CALCULATION_PERIOD, PROJECT_REFERRAL_COMMISSION_CALCULATION_TYPE } from 'constants/project.constants';

export default PropTypes.shape({
    enabled: PropTypes.bool,
    calculationPeriod: PropTypes.oneOf(Object.values(PROJECT_REFERRAL_CALCULATION_PERIOD)),
    calculationType: PropTypes.oneOf(Object.values(PROJECT_REFERRAL_COMMISSION_CALCULATION_TYPE)),
    commission: PropTypes.number
})